// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe{width:100%;height:60vh !important}`, "",{"version":3,"sources":["webpack://./src/components/custom/PDFView/styles.scss"],"names":[],"mappings":"AAAA,OACI,UAAA,CACA,sBAAA","sourcesContent":["iframe{\r\n    width: 100%;\r\n    height: 60vh !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
